import { Settings as SettingsIcon } from 'lucide-react'
import { StyleSettings } from './StyleSettings'
import { NotificationSettings } from './NotificationSettings'
import { useConversationStore } from '../../stores/conversationStore'

export function Settings() {
  const { activeConversationId } = useConversationStore()

  return (
    <div className="h-full flex flex-col bg-background">
      {/* Header */}
      <div className="flex-shrink-0 shadow-md bg-primary">
        {/* Settings Header */}
        <div className="px-4 py-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-white/20 p-2 backdrop-blur-sm">
              <SettingsIcon className="h-5 w-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-white">Settings</h1>
              <p className="text-sm text-white/80">Configure your workspace preferences</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6">
        <div className="max-w-4xl mx-auto space-y-6">
          <NotificationSettings />
          <StyleSettings conversationId={activeConversationId} />
        </div>
      </div>
    </div>
  )
}